import { useState } from "react";
import { getTrackBackground, Range } from "react-range";
import { MAX, MIN, STEP, ThemePrimary } from "../../../../../../constants";
import { useAppDispatch } from "../../../../../../reduxToolkit/hooks";
import { filterPrice } from "../../../../../../reduxToolkit/reducers/eCommerce/filterSlice";

// This component allows users to select a price range using a range slider.
const RangeSlider = () => {
  const dispatch = useAppDispatch();
  const [values, setValues] = useState([20, 50]);
  const priceHandle = (value: number[]) => {
    setValues(value);
    dispatch(filterPrice(value));
  };

  return (
    <Range
      values={values}
      step={STEP}
      min={MIN}
      max={MAX}
      onChange={(values) => priceHandle(values)}
      renderTrack={({ props, children }) => (
        <div onMouseDown={props.onMouseDown} onTouchStart={props.onTouchStart} className="range-track">
          <output className="price-range-output">{values[0]}</output>
          <div ref={props.ref} className="range-track-bar" style={{ background: getTrackBackground({ values, colors: ["#ccc", ThemePrimary, "#ccc"], min: MIN, max: MAX }) }}>
            {children}
          </div>
          <output className="price-range-output">{values[1]}</output>
        </div>
      )}
      renderThumb={({ props, index }) => <div {...props} key={index} className="price-range-thumb" style={{ ...props.style, backgroundColor: ThemePrimary }}></div>}
    />
  );
};

export default RangeSlider;